import styled from 'styled-components';

const Header = styled.header`
  width: 100%;
`;

export default Header;
